import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import anubhav from '../../assets/anubhav.png'
import aric from '../../assets/aric.jpg'
import tyrone from '../../assets/tyrone.jpg'
import vedang from '../../assets/vedang.jpg'
import { FaFacebookF, FaInstagram, FaLinkedin, FaTwitter, FaGithubSquare } from 'react-icons/fa'

const TeamComp = () => {
    return (
        <Container>
            <section className="teamSection">
                <div className="teamHeading">
                    <h1>Meet the Team behind this project</h1>
                </div>
                <Row>
                    <Col lg={6} md={6} sm={12} xs={12}>
                        <div className="eachMember">
                            <Row>
                                <Col lg={7} sm={12} xs={12}>
                                    <img src={anubhav} alt="team member 1" />
                                </Col>
                                <Col lg={5} sm={12} xs={12} className="teamContent">
                                    <div>
                                        <h5>Anubhav Singh</h5>
                                        <p>Web Developer</p>
                                        <a href="#" target="_blank" rel="noreferrer noopener">Link to profile</a>
                                        {/* <div className="teamSocialMedia">


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaFacebookF />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaInstagram />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaLinkedin />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaTwitter />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaGithubSquare />
                                            </a>


                                        </div> */}
                                    </div>

                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12}>
                        <div className="eachMember">
                            <Row>
                                <Col lg={7} sm={12} xs={12}>
                                    <img src={tyrone} alt="team member 2" />
                                </Col>
                                <Col lg={5} sm={12} xs={12} className="teamContent">
                                    <div>
                                        <h5>Tyrone Saldanha</h5>
                                        <p>Web Developer</p>
                                        <a href="#" target="_blank" rel="noreferrer noopener">Link to profile</a>
                                        {/* <div className="teamSocialMedia">


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaFacebookF />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaInstagram />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaLinkedin />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaTwitter />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaGithubSquare />
                                            </a>


                                        </div> */}
                                    </div>

                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6} md={6} sm={12} xs={12}>
                        <div className="eachMember">
                            <Row>
                                <Col lg={7} sm={12} xs={12}>
                                    <img src={vedang} alt="team member 3" />
                                </Col>
                                <Col lg={5} sm={12} xs={12} className="teamContent">
                                    <div>
                                        <h5>Vedang Dubale</h5>
                                        <p>Web Developer</p>
                                        <a href="#" target="_blank" rel="noreferrer noopener">Link to profile</a>
                                        {/* <div className="teamSocialMedia">


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaFacebookF />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaInstagram />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaLinkedin />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaTwitter />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaGithubSquare />
                                            </a>


                                        </div> */}
                                    </div>

                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12}>
                        <div className="eachMember">
                            <Row>
                                <Col lg={7} sm={12} xs={12}>
                                    <img src={aric} alt="team member 4" />
                                </Col>
                                <Col lg={5} sm={12} xs={12} className="teamContent">
                                    <div>
                                        <h5>Aric Pereira</h5>
                                        <p>UI / UX Designer</p>
                                        <a href="#" target="_blank" rel="noreferrer noopener">Link to profile</a>
                                        {/* <div className="teamSocialMedia">


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaFacebookF />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaInstagram />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaLinkedin />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaTwitter />
                                            </a>


                                            <a href="#" target="_blank" rel="noreferrer noopener">
                                                <FaGithubSquare />
                                            </a>


                                        </div> */}
                                    </div>

                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </section>
        </Container>

    )
}
export default TeamComp;